<template>
  <div class="labeled-flex-section">
    <div class="section-label">
      {{ label }}
    </div>

    <div class="section-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "LabeledFlexSection",
  props: {
    label: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/aisea/variables";

.labeled-flex-section {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;

  .section-label {
    font-size: 14px;
    font-weight: 600;
    white-space: nowrap;
  }

  .section-content {
    display: flex;
    gap: 12px;
    flex: 1 0 0;
    flex-wrap: wrap;
  }
}
</style>
